<template>
  <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
    <div class="page_header">
      <span class="page_title">整车数据</span>
      <div style="flex:1;text-align: right;">
        <el-form :inline="true" :size="size" style="flex:1;text-align: right;">
          <el-form-item :label="$t('time.timeQuery')">
            <el-date-picker v-model="queryTime" type="datetimerange" range-separator="至" start-placeholder="开始时间"
              end-placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="onQuery" type="primary">{{ $t('public.query') }}</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button plain type="primary" @click="onExport">{{ $t('public.export') }}</el-button>
          </el-form-item> -->
        </el-form>

      </div>

    </div>
    <el-divider></el-divider>

    <!-- 数据表格 -->
    <div class="page_container">
      <el-table :data="tableData" v-loading="loading" stripe style="width: 100%;">
  <!-- <el-table-column prop="CarNo" align="center" label="车牌号" min-width="120"></el-table-column> -->
        <el-table-column prop="GpsDateTime" align="center" label="时间" min-width="160"></el-table-column>
        <el-table-column prop="vehicleStatus" align="center" label="车辆状态" min-width="120"></el-table-column>
        <el-table-column prop="accStatus" align="center" label="ACC" min-width="120"></el-table-column>
        <el-table-column prop="gearPosition" align="center" label="档位" min-width="120"></el-table-column>
        <el-table-column prop="chargingStatus" align="center" label="充电状态" min-width="120"></el-table-column>
        <el-table-column prop="chargingMode" align="center" label="充电模式" min-width="120"></el-table-column>
        <el-table-column prop="systemFaultLevel" align="center" label="系统故障等级" min-width="120"></el-table-column>
        <el-table-column prop="soc" align="center" label="SOC(%)" min-width="120"></el-table-column>
        <el-table-column prop="insideTemperature" align="center" label="车内温度" min-width="120"></el-table-column>
        <el-table-column prop="outsideTemperature" align="center" label="车外温度" min-width="120"></el-table-column>
        <el-table-column prop="brakePedalTravel" align="center" label="刹车行程值" min-width="120"></el-table-column>
        <el-table-column prop="acceleratorPedalTravel" align="center" label="加速踏板行程值" min-width="120"></el-table-column>
        <el-table-column prop="totalChargingEnergy" align="center" label="总充电量(kwh)" min-width="120"></el-table-column>
        <el-table-column prop="totalEnergyConsumption" align="center" label="总耗电量(kwh)" min-width="120"></el-table-column>
        <el-table-column prop="averageEnergyConsumption" align="center" label="平均电耗(kwh/km)" min-width="120"></el-table-column>
        <el-table-column prop="totalMileage" align="center" label="总里程(km)" min-width="120"></el-table-column>
        <el-table-column prop="drivingSpeed" align="center" label="行驶速度(km/h)" min-width="120"></el-table-column>
        <el-table-column prop="positiveInsulationResistance" align="center" label="正极绝缘电阻阻值(Ω)" min-width="140"></el-table-column>
        <el-table-column prop="faultComponentCode" align="center" label="故障部件代号" min-width="120"></el-table-column>
        <el-table-column prop="dcdcStatus" align="center" label="DCDC状态" min-width="120"></el-table-column>
        <el-table-column prop="dcTemperature" align="center" label="DC温度(℃)" min-width="120"></el-table-column>
        <el-table-column prop="batteryInletWaterTemp" align="center" label="锂电池进水温度(℃)" min-width="140"></el-table-column>
        <el-table-column prop="batteryOutletWaterTemp" align="center" label="锂电池出水温度(℃)" min-width="140"></el-table-column>
        <el-table-column prop="tmsStatus" align="center" label="TMS工作状态" min-width="120"></el-table-column>
        <el-table-column prop="highVoltageEmergencySwitchStatus" align="center" label="高压急停开关状态" min-width="120"></el-table-column>
        <el-table-column prop="chargingCableConnectionStatus" align="center" label="充电线连接状态" min-width="120"></el-table-column>



      </el-table>
      <kl-pagination style="margin-bottom: 10px;" :pageSize="form.PageSize" :total="total" @current-change="pageChange"
        :current-page.sync="form.PageNo">
      </kl-pagination>
    </div>


  </div>
</template>

<script>
import quickQuery from "../components/generalOrQuickQuery.vue";
import { QueryAbroadCANVehicle } from '@/http/vehicle'
import language from '@/utils/getLanguageId';
import { mapState } from 'vuex'
export default {
  name: 'LongOfflineStatistics',
  components: {
    quickQuery
  },
  computed: {
    LanguageId() {
      return language(this.$store.getters.locale)
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
      size: state => state.app.size
    }),
  },
  data() {
    return {
      // 搜索表单
      form: {
        PageNo: 1,
        PageSize: 10
      },
      loading: false,
      queryTime: undefined,
      beginDate: undefined,
      endDate: undefined,
      // 表格数据
      tableData: [],
      total: 0,

    }
  },
  mounted() {
    //queryTime 默认时间为当天的
    this.queryTime = [new Date(), new Date()]
    this.beginDate = this.queryTime[0]
    this.endDate = this.queryTime[1]
    this.beginDate.setHours(0, 0, 0, 0)
    this.endDate.setHours(23, 59, 59, 999)
  },
  methods: {
    getSelectedVehicles() {
      let vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          vehicles = vehicles + this.selectedVehicles[k].mobile + ",";
        }
      }
      return vehicles.substring(0, vehicles.length - 1);
    },
    onExport() {

      //数据导出
      this.loadData(1);
    },
    onQuery(val) {
      this.beginDate = this.queryTime[0];
      this.endDate = this.queryTime[1];
      //格式化为 yyyy-MM-dd HH:mm:ss
      this.beginDate = this.beginDate.toLocaleString().replace(/\//g, '-')
      this.endDate = this.endDate.toLocaleString().replace(/\//g, '-')
      // console.log(this.beginDate, this.endDate)
      // this.getSelectedVehicles();
       this.loadData();
    },
    // 加载数据
    loadData(isExport) {
      isExport = isExport || 0;
      this.loading = true

      // 实际项目中取消注释以下代码
      QueryAbroadCANVehicle({
         "BeginTime": this.beginDate,
        "Language": this.LanguageId,
        "DeviceNo": this.getSelectedVehicles(),
        "EndTime": this.endDate,
        "IsExport": isExport,
        "TimeZone": 8,
        "PageNo": this.form.PageNo, "PageSize": this.form.PageSize
      }, isExport == 1 ? 'blob' : 'json').then(res => {
        this.loading = false
        if (isExport == 1) {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码

          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download =  '整车数据.xlsx'; // 默认文件名
          // a.setAttribute(
          //     "download",
          //     "充电记录.xlsx"
          // ); // 表名，自定义
          // document.body.appendChild(a);
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          // window.open(settings.baseUrl + "longyi/xlsx/" + res.data)
        } else {

          this.tableData = res.data || []
          this.total = res.recordsTotal || 0

        }
      })



    },
    // 分页变化
    pageChange(page) {
      this.form.PageNo = page;
      this.loadData();
    },
  }
}
</script>

<style scoped>
/* 响应式设计 */
</style>